import { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const PayPeriodEmptyIcon = ({
  width = '140',
  height = '140'
}: Omit<IconSvgProps, 'children'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 144 146"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="71.5" cy="70.9062" r="70" fill="#F9F9F9" />
      <path
        d="M111.239 121.953C111.811 120.856 113.381 120.856 113.954 121.953L117.325 128.408C117.397 128.546 117.511 128.66 117.649 128.732L124.107 132.105C125.204 132.678 125.204 134.248 124.107 134.82L117.649 138.189C117.511 138.262 117.397 138.375 117.325 138.514L113.954 144.972C113.381 146.069 111.811 146.069 111.239 144.971L107.873 138.514C107.8 138.375 107.687 138.262 107.548 138.189L101.087 134.82C99.9894 134.248 99.9892 132.677 101.086 132.105L107.548 128.732C107.687 128.66 107.8 128.546 107.873 128.407L111.239 121.953Z"
        fill="#CCCCCC"
      />
      <path
        d="M33.1277 2.58573C33.4606 1.94744 34.3739 1.94719 34.7071 2.58531L36.6678 6.34007C36.7099 6.42074 36.7758 6.48656 36.8564 6.52869L40.6127 8.49052C41.2507 8.82373 41.2505 9.73682 40.6124 10.0698L36.8566 12.0297C36.7758 12.0718 36.7099 12.1377 36.6678 12.2184L34.7072 15.9747C34.374 16.613 33.4604 16.6128 33.1276 15.9743L31.1699 12.2186C31.1277 12.1378 31.0618 12.0718 30.9809 12.0296L27.2228 10.0699C26.5844 9.73701 26.5842 8.82354 27.2225 8.4904L30.981 6.52875C31.0618 6.48659 31.1277 6.42066 31.1699 6.33986L33.1277 2.58573Z"
        fill="#CCCCCC"
      />
      <path
        d="M137.335 38.8038C137.581 38.3322 138.256 38.332 138.502 38.8035L139.951 41.5782C139.982 41.6378 140.03 41.6864 140.09 41.7175L142.866 43.1673C143.337 43.4135 143.337 44.0882 142.866 44.3343L140.09 45.7825C140.031 45.8137 139.982 45.8624 139.951 45.922L138.502 48.6978C138.256 49.1695 137.581 49.1693 137.335 48.6975L135.888 45.9222C135.857 45.8624 135.808 45.8137 135.748 45.7825L132.971 44.3344C132.499 44.0884 132.499 43.4133 132.971 43.1672L135.748 41.7176C135.808 41.6864 135.857 41.6377 135.888 41.578L137.335 38.8038Z"
        fill="#EFEFF0"
      />
      <path
        d="M7.00113 97.9081C7.35938 97.2212 8.34229 97.2209 8.70091 97.9077L10.8111 101.949C10.8564 102.035 10.9273 102.106 11.0141 102.152L15.0567 104.263C15.7433 104.622 15.7431 105.604 15.0564 105.963L11.0142 108.072C10.9273 108.117 10.8564 108.188 10.811 108.275L8.701 112.318C8.34243 113.005 7.35924 113.004 7.00104 112.317L4.89411 108.275C4.84873 108.188 4.77773 108.117 4.69069 108.072L0.646163 105.963C-0.0408995 105.604 -0.0410786 104.621 0.645854 104.263L4.69084 102.152C4.77778 102.106 4.84871 102.035 4.89406 101.948L7.00113 97.9081Z"
        fill="#EFEFF0"
      />
      <path
        d="M24.914 34.8896V88.0859C24.914 89.7428 26.2572 91.0859 27.914 91.0859H47.3298H68.8743C70.4566 91.0859 71.7393 89.8032 71.7393 88.2209V46.5846V42.8251C71.7393 42.5599 71.6339 42.3055 71.4464 42.118L61.5109 32.1825C61.3234 31.995 61.069 31.8896 60.8038 31.8896H27.914C26.2572 31.8896 24.914 33.2328 24.914 34.8896Z"
        fill="white"
      />
      <path
        d="M55.1182 103.549H86.0522H107.949C109.355 103.549 110.495 102.409 110.495 101.003V69.1696V64.5789L52.1182 64.5781V100.549C52.1182 102.206 53.4613 103.549 55.1182 103.549Z"
        fill="white"
      />
      <path
        d="M55.1182 103.549H86.0522H107.949C109.355 103.549 110.495 102.409 110.495 101.003V69.1696V64.5789L52.1182 64.5781V100.549C52.1182 102.206 53.4613 103.549 55.1182 103.549Z"
        stroke="#7E7E7E"
        strokeWidth="1.5"
      />
      <path
        d="M52.1182 56.8184V65.0108H110.495V56.8184C110.495 55.1615 109.152 53.8184 107.495 53.8184H55.1182C53.4613 53.8184 52.1182 55.1615 52.1182 56.8184Z"
        fill="white"
        stroke="#7E7E7E"
        strokeWidth="1.5"
      />
      <rect
        x="65.0713"
        y="49.4824"
        width="4.76663"
        height="8.66985"
        rx="1.27288"
        fill="#7E7E7E"
      />
      <rect
        x="92.7705"
        y="49.4824"
        width="4.76663"
        height="8.66985"
        rx="1.27288"
        fill="#7E7E7E"
      />
      <path
        d="M51.6866 91.0859H27.914C26.2572 91.0859 24.914 89.7428 24.914 88.0859V34.8896C24.914 33.2328 26.2572 31.8896 27.914 31.8896H60.8038C61.069 31.8896 61.3234 31.995 61.5109 32.1825L71.4464 42.118C71.6339 42.3055 71.7393 42.5599 71.7393 42.8251V53.5916"
        stroke="#7E7E7E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.3174 84.8457V70.8457H36.2421V84.8457H31.3174Z"
        fill="#7E7E7E"
        stroke="#7E7E7E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.0166 84.8457V64.8457H45.9413V84.8457H41.0166Z"
        fill="#7E7E7E"
        stroke="#7E7E7E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.3174 40.6113L55.5583 40.6113"
        stroke="#7E7E7E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.3174 46.8574L46.6879 46.8574"
        stroke="#7E7E7E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M122.912 90.5663C122.912 100.185 115.115 107.982 105.496 107.982C95.8779 107.982 88.0806 100.185 88.0806 90.5663C88.0806 80.9478 95.8779 73.1504 105.496 73.1504C115.115 73.1504 122.912 80.9478 122.912 90.5663Z"
        fill="white"
      />
      <mask id="path-18-inside-1_2490_70065" fill="white">
        <path d="M116.612 90.5664C116.612 96.7828 111.573 101.822 105.356 101.822C99.14 101.822 94.1006 96.7828 94.1006 90.5664C94.1006 84.35 99.14 79.3105 105.356 79.3105C111.573 79.3105 116.612 84.35 116.612 90.5664Z" />
      </mask>
      <path
        d="M116.612 90.5664C116.612 96.7828 111.573 101.822 105.356 101.822C99.14 101.822 94.1006 96.7828 94.1006 90.5664C94.1006 84.35 99.14 79.3105 105.356 79.3105C111.573 79.3105 116.612 84.35 116.612 90.5664Z"
        fill="#31B59F"
      />
      <path
        d="M115.821 90.5664C115.821 96.346 111.136 101.031 105.356 101.031V102.613C112.01 102.613 117.403 97.2197 117.403 90.5664H115.821ZM105.356 101.031C99.5768 101.031 94.8915 96.346 94.8915 90.5664H93.3097C93.3097 97.2197 98.7032 102.613 105.356 102.613V101.031ZM94.8915 90.5664C94.8915 84.7868 99.5768 80.1015 105.356 80.1015V78.5196C98.7032 78.5196 93.3097 83.9132 93.3097 90.5664H94.8915ZM105.356 80.1015C111.136 80.1015 115.821 84.7868 115.821 90.5664H117.403C117.403 83.9132 112.01 78.5196 105.356 78.5196V80.1015Z"
        fill="#31B59F"
        mask="url(#path-18-inside-1_2490_70065)"
      />
      <path
        d="M105.099 97.0925C104.345 97.0925 103.627 96.9668 102.945 96.7154C102.274 96.464 101.712 96.0331 101.257 95.4226L102.514 94.3273C102.777 94.7343 103.142 95.0575 103.609 95.2969C104.088 95.5363 104.585 95.668 105.099 95.6919V91.1311C104.633 91.0114 104.184 90.8558 103.753 90.6643C103.322 90.4608 102.939 90.2154 102.604 89.9281C102.28 89.6408 102.023 89.2996 101.831 88.9046C101.64 88.4976 101.544 88.0247 101.544 87.4861C101.544 86.9833 101.64 86.5224 101.831 86.1035C102.023 85.6845 102.28 85.3254 102.604 85.0261C102.939 84.7149 103.322 84.4695 103.753 84.2899C104.184 84.0984 104.633 83.9847 105.099 83.9488V82.7637H105.961V83.9488C106.608 83.9488 107.242 84.0685 107.865 84.3079C108.499 84.5473 109.026 84.9124 109.445 85.4032L108.26 86.4805C107.984 86.1214 107.649 85.8461 107.254 85.6546C106.859 85.4511 106.428 85.3493 105.961 85.3493V89.8203C106.44 89.976 106.907 90.1435 107.362 90.3231C107.817 90.5027 108.218 90.7301 108.565 91.0054C108.924 91.2688 109.205 91.598 109.409 91.993C109.624 92.388 109.732 92.8788 109.732 93.4654C109.732 94.0041 109.63 94.4889 109.427 94.9198C109.223 95.3507 108.948 95.7218 108.601 96.0331C108.266 96.3443 107.871 96.5897 107.416 96.7693C106.961 96.9488 106.476 97.0566 105.961 97.0925V98.3673H105.099V97.0925ZM105.099 85.3493C104.513 85.4571 104.04 85.7025 103.681 86.0855C103.334 86.4566 103.16 86.9294 103.16 87.504C103.16 87.8153 103.208 88.0786 103.304 88.2941C103.412 88.5096 103.549 88.6951 103.717 88.8507C103.896 89.0063 104.1 89.144 104.327 89.2637C104.567 89.3714 104.824 89.4792 105.099 89.5869V85.3493ZM105.961 95.6919C106.572 95.6201 107.081 95.3867 107.488 94.9916C107.906 94.5966 108.116 94.1118 108.116 93.5372C108.116 93.214 108.056 92.9327 107.936 92.6933C107.817 92.4539 107.655 92.2504 107.452 92.0828C107.248 91.9152 107.015 91.7775 106.751 91.6698C106.5 91.5501 106.237 91.4483 105.961 91.3645V95.6919Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M88.9412 87.0192C86.8659 96.1032 92.5477 105.15 101.632 107.225C110.716 109.3 119.762 103.618 121.837 94.5343C123.912 85.4503 118.231 76.4039 109.147 74.3287C104.833 73.3432 100.528 74.1066 96.9736 76.1536C95.897 76.7735 94.8894 77.511 93.9714 78.3532L96.8173 78.5555L97.316 78.591L97.2451 79.5885L96.7463 79.553L92.7263 79.2672C92.5918 79.2576 92.4668 79.1941 92.3797 79.091C92.2927 78.9879 92.251 78.854 92.2642 78.7198L92.6566 74.7084L92.7053 74.2108L93.7006 74.3082L93.6519 74.8058L93.3849 77.5347C94.333 76.6767 95.3695 75.9233 96.4745 75.287C100.239 73.1193 104.8 72.31 109.369 73.3538C118.992 75.552 125.01 85.1345 122.812 94.757C120.614 104.379 111.031 110.398 101.409 108.2C91.7866 106.001 85.7681 96.4189 87.9663 86.7965L88.9412 87.0192Z"
        fill="#7E7E7E"
      />
      <path
        d="M59.9033 77.4719V71.8719C59.9033 71.4853 60.2167 71.1719 60.6033 71.1719H66.2033C66.5899 71.1719 66.9033 71.4853 66.9033 71.8719V77.4719C66.9033 77.8585 66.5899 78.1719 66.2033 78.1719H60.6033C60.2167 78.1719 59.9033 77.8585 59.9033 77.4719Z"
        fill="#7E7E7E"
      />
      <path
        d="M63.2005 76.8457V73.7257L62.4085 74.3377L61.8865 73.6237L63.2845 72.5977H64.2085V76.8457H63.2005Z"
        fill="white"
      />
      <path
        d="M59.9658 87.5031V81.9031C59.9658 81.5165 60.2792 81.2031 60.6658 81.2031H66.2658C66.6524 81.2031 66.9658 81.5165 66.9658 81.9031V87.5031C66.9658 87.8897 66.6524 88.2031 66.2658 88.2031H60.6658C60.2792 88.2031 59.9658 87.8897 59.9658 87.5031Z"
        fill="#7E7E7E"
      />
      <path
        d="M59.9658 97.5031V91.9031C59.9658 91.5165 60.2792 91.2031 60.6658 91.2031H66.2658C66.6524 91.2031 66.9658 91.5165 66.9658 91.9031V97.5031C66.9658 97.8897 66.6524 98.2031 66.2658 98.2031H60.6658C60.2792 98.2031 59.9658 97.8897 59.9658 97.5031Z"
        fill="#7E7E7E"
      />
      <path
        d="M74.3057 87.4719V81.8719C74.3057 81.4853 74.6191 81.1719 75.0057 81.1719H80.6057C80.9923 81.1719 81.3057 81.4853 81.3057 81.8719V87.4719C81.3057 87.8585 80.9923 88.1719 80.6057 88.1719H75.0057C74.6191 88.1719 74.3057 87.8585 74.3057 87.4719Z"
        fill="#7E7E7E"
      />
      <path
        d="M74.3057 97.4719V91.8719C74.3057 91.4853 74.6191 91.1719 75.0057 91.1719H80.6057C80.9923 91.1719 81.3057 91.4853 81.3057 91.8719V97.4719C81.3057 97.8585 80.9923 98.1719 80.6057 98.1719H75.0057C74.6191 98.1719 74.3057 97.8585 74.3057 97.4719Z"
        fill="#7E7E7E"
      />
      <path
        d="M74.3057 77.4719V71.8719C74.3057 71.4853 74.6191 71.1719 75.0057 71.1719H80.6057C80.9923 71.1719 81.3057 71.4853 81.3057 71.8719V77.4719C81.3057 77.8585 80.9923 78.1719 80.6057 78.1719H75.0057C74.6191 78.1719 74.3057 77.8585 74.3057 77.4719Z"
        fill="#7E7E7E"
      />
    </svg>
  )
}

export default PayPeriodEmptyIcon
